import * as React from 'react';

import { Header } from 'common/components';
import Routes from '../concierge/Routes';
import { WhitelabelContainer } from '../index';

import logo from 'assets/img/TC_Concierge.png';

class Concierge extends WhitelabelContainer {
  getContent = () => {
    return (
      <>
        <Header logo={logo} />
        <Routes />
      </>
    );
  };

  componentDidMount() {
    console.log('Mandator: Concierge');
  }
}

export default Concierge;
